// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.order.AddPatientOwnedFrameRequest */
/* istanbul ignore next */
@GandalfModel
export class AddPatientOwnedFrameRequest extends GandalfModelBase {

	@GandalfProperty({ designType: Number })
	a!: number | null;

	@GandalfProperty({ designType: Number })
	b!: number | null;

	@GandalfProperty({ designType: Number })
	brandId!: number | null;

	@GandalfProperty({ designType: Number })
	bridge!: number | null;

	@GandalfProperty({ designType: Number })
	circumference!: number | null;

	@GandalfProperty({ designType: Number })
	collectionId!: number | null;

	@GandalfValidator({ sizeString: { message: 'Color Code cannot be longer than 50 characters', minLength: 0, maxLength: 50 } })
	@GandalfProperty({ designType: String })
	colorCode!: string | null;

	@GandalfValidator({ sizeString: { message: 'Color Name cannot be longer than 100 characters', minLength: 0, maxLength: 100 } })
	@GandalfProperty({ designType: String })
	colorName!: string | null;

	@GandalfProperty({ designType: Number })
	dbl!: number | null;

	@GandalfProperty({ designType: Number })
	ed!: number | null;

	@GandalfProperty({ designType: Number })
	edAngle!: number | null;

	@GandalfProperty({ designType: Number })
	eye!: number | null;

	@GandalfValidator({ notNull: { message: 'Location is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	locationId!: number;

	@GandalfValidator({ sizeString: { message: 'Model cannot be longer than 100 characters', minLength: 0, maxLength: 100 } })
	@GandalfProperty({ designType: String })
	locationProductName!: string | null;

	@GandalfValidator({ notNull: { message: 'Manufacturer is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	manufacturerId!: number;

	@GandalfProperty({ designType: Number })
	screwToScrew!: number | null;

	@GandalfProperty({ designType: Number })
	temple!: number | null;

	@GandalfValidator({ sizeString: { message: 'Temple Unit cannot be longer than 20 characters', minLength: 0, maxLength: 20 } })
	@GandalfProperty({ designType: String })
	templeUnit!: string | null;

}
